<div class="overlay"></div>
<div class="panel">
  <div class="inside-panel">
    <h2>{{ labelService.getLabel(title) }}</h2>

    <form [formGroup]="eventForm" class="appointment-section">
      <mat-form-field appearance="fill">
        <mat-label>Titolo</mat-label>
        <input matInput formControlName="title" type="text" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Data</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <div class="time-fields">
        @if (!eventForm.get("isAllDay")?.value) {
          <mat-form-field appearance="fill">
            <mat-label>Ora Inizio</mat-label>
            <input matInput formControlName="startTime" type="time" />
          </mat-form-field>
        }

        @if (!eventForm.get("isAllDay")?.value) {
          <mat-form-field appearance="fill">
            <mat-label>Durata</mat-label>
            <input
              matInput
              formControlName="length"
              placeholder="45"
              type="number"
            />
          </mat-form-field>
        }
      </div>
    </form>

    <div class="panel-buttons">
      <button class="button-white" mat-stroked-button (click)="onDelete()">
        {{ labelService.getLabel("Elimina") }}
      </button>
      <button class="button-white" mat-stroked-button (click)="onCancel()">
        {{ labelService.getLabel("cancel") }}
      </button>
      <button
        class="button-white"
        mat-stroked-button
        (click)="onConfirm()"
        [disabled]="
          !eventForm.valid || isBtnClicked || !isAppointmentModifiable
        "
      >
        {{ labelService.getLabel("confirm") }}
      </button>
    </div>
    @if (eventForm.invalid && (eventForm.touched || eventForm.dirty)) {
      <mat-error>
        Compila tutti i campi correttamente prima di confermare
      </mat-error>
    }
    @if (!isAppointmentModifiable) {
      <mat-error>
        Google non ha i permessi per modificare questo evento.
      </mat-error>
    }
  </div>
</div>
